module.exports = __webpack_public_path__ + "static/media/3_FR.b1976a40.mp3";